import React, { useCallback, useState } from "react";
import PreviewBlog from "../helpers/blog/PreviewBlog";
import BlogEditor from "../helpers/blog/BlogEditor";
import PublishModal from "../helpers/blog/PublishFormModal";

const CreateBlog = () => {
  const [value, setValue] = useState("");

  const [showPreview, setShowPreview] = useState(false);
  const [showPublish, setShowPublish] = useState(false);

  const hanldeGoBack = useCallback(() => setShowPreview(false), []);
  const hanldePublish = () => {
    if (value.trim() === "") {
      alert("blog can't be empty");
      return;
    }
    setShowPublish(true);
  };
  return (
    <div className="min-h-screen">
      {showPublish && (
        <PublishModal
          setShowPublish={setShowPublish}
          content={value}
          isPublish
          blogId=""
        />
      )}
      {showPreview ? (
        <PreviewBlog value={value} handleGoBack={hanldeGoBack} />
      ) : (
        <>
          <header className="max-h-max flex justify-between items-center px-4">
            <h3 className="text-xl font-bold mb-4">Create Blog</h3>
            <div className="[&>button]:font-medium [&>button]:text-xl flex gap-2 [&>button]:px-4 [&>button]:py-2 [&>button]:text-white [&>button]:rounded-[5px] ">
              <button
                className="bg-[#A8A8A8]"
                onClick={() => setShowPreview(true)}
              >
                Preview
              </button>
              <button className="bg-[#88087B]" onClick={hanldePublish}>
                Publish
              </button>
            </div>
          </header>
          <div className="w-full px-4 pt-4">
            <BlogEditor setValue={setValue} value={value} />
          </div>
        </>
      )}
    </div>
  );
};

export default CreateBlog;
